<mat-toolbar color="primary">
  <mat-toolbar-row>
    <button mat-icon-button (click)="sidenav.toggle();">
      <mat-icon>menu</mat-icon>
    </button>

    <img src="assets/logo.png" alt="logo" style="margin-left: 20px; max-height: 45px;;" (click)="goToHome()">
    <div *ngIf="innerWidth > 530"
      style="margin-left: 10px; font-family:'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;">
      Distribuidora Ipanema</div>


    <div fxFlex fxLayout="row" fxLayoutAlign="flex-end">
      <ul fxLayout="row" fxLayoutGap="20px">
        <!-- <li>
                    <button mat-icon-button>
                        <mat-icon>settings</mat-icon>
                    </button>
                </li> -->

        <li *ngIf="contBoletosVencidos >=1">
          <button mat-icon-button (click)='navegarRelatorioBoletos()'
            *ngIf="uid === idCliente && contBoletosVencidos >= 1">
            <mat-icon [matBadge]="contBoletosVencidos" matBadgeColor="warn"
              matTooltip="Boletos vencidos">local_atm</mat-icon>
          </button>
        </li>

        <li *ngIf="contSolicitacoesExclusaoDados >=1">
          <button mat-icon-button (click)='navegarSolicitacoesExclusaoDados()'
            *ngIf="uid === idCliente && contSolicitacoesExclusaoDados >= 1">
            <mat-icon [matBadge]="contSolicitacoesExclusaoDados" matBadgeColor="warn"
              matTooltip="Solicitações de exclusão de dados">delete</mat-icon>
          </button>
        </li>

        <li *ngIf="contErroCadastroLatLng >=1">
          <button mat-icon-button (click)='navegarErroLatLng()'
            *ngIf="uid === idCliente && contErroCadastroLatLng >= 1">
            <mat-icon [matBadge]="contErroCadastroLatLng" matBadgeColor="warn"
              [matBadgeHidden]="hiddenBadgeErroCadastroLatLng"
              matTooltip="Erro de validação Latitude Longitude em usuários">account_box</mat-icon>
          </button>
        </li>

        <!-- <li *ngIf="contValidacaoEstoque >=1">
          <button mat-icon-button (click)='navegarValidarEstoque()'
            *ngIf="uid === idCliente && contValidacaoEstoque >= 1">
            <mat-icon [matBadge]="contValidacaoEstoque" matBadgeColor="warn"
              [matBadgeHidden]="hiddenBadgeValidarEstoque" matTooltip="Validar estoque">warning</mat-icon>
          </button>
        </li> -->

        <li>
          <button mat-icon-button (click)='navegarAlertaEstoque()'
            *ngIf="uid === idCliente && contQuantidadeMinimaEstoque >= 1">
            <mat-icon [matBadge]="contQuantidadeMinimaEstoque" matBadgeColor="warn" matTooltip="Alerta estoque">
              error</mat-icon>
          </button>
        </li>

        <li>
          <button mat-icon-button (click)='navegarPedidos()' *ngIf="uid === idCliente">
            <mat-icon [matBadge]="contConfirmados + contEmSeparacao + contEmRota" matBadgeColor="warn"
              [matBadgeHidden]="hiddenBadgeNovosPedidos" matTooltip="Novos pedidos">bookmark</mat-icon>
          </button>
        </li>

        <li>
          <button mat-icon-button (click)='navegarSolicitacoes()' *ngIf="uid === idCliente">
            <mat-icon [matBadge]="contSolicitacoesCadastro" matBadgeColor="warn"
              [matBadgeHidden]="hiddenBadgeSolicitacoesCadastro" matTooltip="Solicitações de cadastro">
              add_alert</mat-icon>
          </button>
        </li>

        <li>
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>person_outline</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)='signOut()'>
              <mat-icon>exit_to_app</mat-icon>
              Sair
            </button>
          </mat-menu>
        </li>
      </ul>
    </div>
  </mat-toolbar-row>
</mat-toolbar>
